// Bilingual Tutor System Data
// This file contains data for the bilingual tutor system and interactive sessions

export const bilingualTutorSessions = [
  {
    id: 'session_1',
    title: {
      traditional: '基礎對話練習',
      simplified: '基础对话练习',
      english: 'Basic Conversation Practice'
    },
    description: {
      traditional: '學習基本的日常對話和問候語',
      simplified: '学习基本的日常对话和问候语',
      english: 'Learn basic daily conversations and greetings'
    },
    difficulty: 'beginner',
    duration: '15-20 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: true,
    topics: [
      'Greetings and introductions',
      'Basic questions and answers',
      'Daily activities',
      'Simple expressions'
    ],
    targetSkills: [
      'Master basic greetings',
      'Ask and answer simple questions',
      'Describe daily activities',
      'Use common expressions'
    ]
  },
  {
    id: 'session_2',
    title: {
      traditional: '商務英語會話',
      simplified: '商务英语会话',
      english: 'Business English Conversation'
    },
    description: {
      traditional: '掌握商務場合的英語對話技巧',
      simplified: '掌握商务场合的英语对话技巧',
      english: 'Master English conversation skills for business situations'
    },
    difficulty: 'intermediate',
    duration: '25-30 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: true,
    topics: [
      'Business meetings',
      'Professional presentations',
      'Negotiations',
      'Email communication'
    ],
    targetSkills: [
      'Conduct business meetings',
      'Give professional presentations',
      'Handle negotiations',
      'Write business emails'
    ]
  },
  {
    id: 'session_3',
    title: {
      traditional: '旅遊英語實用',
      simplified: '旅游英语实用',
      english: 'Practical Travel English'
    },
    description: {
      traditional: '學習旅遊時實用的英語表達',
      simplified: '学习旅游时实用的英语表达',
      english: 'Learn practical English expressions for travel'
    },
    difficulty: 'beginner',
    duration: '20-25 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: false,
    topics: [
      'Airport and transportation',
      'Hotel check-in and check-out',
      'Restaurant ordering',
      'Shopping and bargaining'
    ],
    targetSkills: [
      'Navigate airports and transportation',
      'Handle hotel procedures',
      'Order food in restaurants',
      'Shop and bargain effectively'
    ]
  },
  {
    id: 'session_4',
    title: {
      traditional: '學術英語討論',
      simplified: '学术英语讨论',
      english: 'Academic English Discussion'
    },
    description: {
      traditional: '參與學術討論和研究的英語表達',
      simplified: '参与学术讨论和研究的英语表达',
      english: 'English expressions for academic discussions and research'
    },
    difficulty: 'advanced',
    duration: '30-35 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: false,
    topics: [
      'Academic presentations',
      'Research discussions',
      'Critical thinking',
      'Academic writing'
    ],
    targetSkills: [
      'Deliver academic presentations',
      'Participate in research discussions',
      'Express critical thinking',
      'Write academic content'
    ]
  },
  {
    id: 'session_5',
    title: {
      traditional: '社交英語技巧',
      simplified: '社交英语技巧',
      english: 'Social English Skills'
    },
    description: {
      traditional: '提升社交場合的英語溝通能力',
      simplified: '提升社交场合的英语沟通能力',
      english: 'Enhance English communication skills in social settings'
    },
    difficulty: 'intermediate',
    duration: '25-30 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: false,
    topics: [
      'Making friends',
      'Small talk',
      'Expressing opinions',
      'Cultural differences'
    ],
    targetSkills: [
      'Make new friends',
      'Engage in small talk',
      'Express opinions clearly',
      'Navigate cultural differences'
    ]
  },
  {
    id: 'session_6',
    title: {
      traditional: '電話英語溝通',
      simplified: '电话英语沟通',
      english: 'Telephone English Communication'
    },
    description: {
      traditional: '掌握電話溝通的英語技巧',
      simplified: '掌握电话沟通的英语技巧',
      english: 'Master English skills for telephone communication'
    },
    difficulty: 'intermediate',
    duration: '20-25 mins',
    languageOptions: ['english', 'taiwanese'],
    isCompleted: false,
    isUnlocked: false,
    topics: [
      'Making phone calls',
      'Taking messages',
      'Handling complaints',
      'Professional phone etiquette'
    ],
    targetSkills: [
      'Make effective phone calls',
      'Take accurate messages',
      'Handle customer complaints',
      'Maintain professional phone etiquette'
    ]
  }
];

export const languageOptions = [
  {
    id: 'english',
    name: {
      traditional: '英語',
      simplified: '英语',
      english: 'English'
    },
    flag: '🇺🇸',
    description: {
      traditional: '標準英語發音和表達',
      simplified: '标准英语发音和表达',
      english: 'Standard English pronunciation and expressions'
    }
  },
  {
    id: 'taiwanese',
    name: {
      traditional: '台灣 / 台灣',
      simplified: '台湾 / 台湾',
      english: 'Taiwanese / 台灣'
    },
    flag: '🇹🇼',
    description: {
      traditional: '台灣英語發音特色',
      simplified: '台湾英语发音特色',
      english: 'Taiwanese English pronunciation features'
    }
  }
];

export const sessionContent = {
  'session_1': {
    greeting: {
      traditional: '你好，John！',
      simplified: '你好，John！',
      english: 'Good day, John!'
    },
    languagePrompt: {
      traditional: '對於這個課程，請選擇您希望 ELSA 用哪種語言與您對話？',
      simplified: '对于这个课程，请选择您希望 ELSA 用哪种语言与您对话？',
      english: 'For this session, please pick the language you\'d want ELSA to speak to you in?'
    },
    lessonIntroduction: {
      traditional: 'John，在本課中我們將探討如何儲存和保持教學物質，我們將有一個有用的機會來練習課程定義練習等的不喜談論。',
      simplified: 'John，在本课中我们将探讨如何储存和保持教学物质，我们将有一个有用的机会来练习课程定义练习等的不喜谈论。',
      english: 'John, in this lesson we will explore how to store and maintain teaching materials. We will have a useful opportunity to practice course definitions and other unpleasant discussions.'
    },
    readinessPrompt: {
      traditional: '你準備好了嗎？',
      simplified: '你准备好了吗？',
      english: 'Are you ready?'
    },
    voicePrompt: {
      traditional: '點擊說話',
      simplified: '点击说话',
      english: 'Tap to Speak'
    },
    exercises: [
      {
        id: 'ex_1_1',
        type: 'greeting',
        prompt: {
          traditional: '請用英語說「你好」',
          simplified: '请用英语说「你好」',
          english: 'Please say "Hello" in English'
        },
        expectedResponse: 'Hello',
        feedback: {
          traditional: '很好！發音很清晰。',
          simplified: '很好！发音很清晰。',
          english: 'Great! Your pronunciation is very clear.'
        }
      },
      {
        id: 'ex_1_2',
        type: 'question',
        prompt: {
          traditional: '請問「你叫什麼名字？」',
          simplified: '请问「你叫什么名字？」',
          english: 'Please ask "What is your name?"'
        },
        expectedResponse: 'What is your name?',
        feedback: {
          traditional: '正確！語調很自然。',
          simplified: '正确！语调很自然。',
          english: 'Correct! Your intonation is very natural.'
        }
      }
    ]
  }
};

export const userSessionProgress = {
  userId: 'peter',
  currentSession: null,
  completedSessions: [],
  sessionScores: {},
  totalTimeSpent: 0,
  preferredLanguage: 'english',
  voiceSettings: {
    speed: 'normal',
    pitch: 'normal',
    volume: 'medium'
  }
};

// Helper functions
export const getBilingualTutorSessions = () => bilingualTutorSessions;

export const getBilingualTutorSessionById = (sessionId) => {
  return bilingualTutorSessions.find(session => session.id === sessionId);
};

export const getLanguageOptions = () => languageOptions;

export const getLanguageOptionById = (languageId) => {
  return languageOptions.find(lang => lang.id === languageId);
};

export const getSessionContent = (sessionId) => {
  return sessionContent[sessionId] || null;
};

export const getUserSessionProgress = () => userSessionProgress;

export const updateUserSessionProgress = (sessionId, score, timeSpent) => {
  if (!userSessionProgress.completedSessions.includes(sessionId)) {
    userSessionProgress.completedSessions.push(sessionId);
  }
  userSessionProgress.sessionScores[sessionId] = score;
  userSessionProgress.totalTimeSpent += timeSpent;
};

export const setCurrentSession = (sessionId) => {
  userSessionProgress.currentSession = sessionId;
};

export const updatePreferredLanguage = (languageId) => {
  userSessionProgress.preferredLanguage = languageId;
};

export const updateVoiceSettings = (settings) => {
  userSessionProgress.voiceSettings = { ...userSessionProgress.voiceSettings, ...settings };
};

export const calculateSessionProgress = () => {
  const totalSessions = bilingualTutorSessions.length;
  const completedSessions = userSessionProgress.completedSessions.length;
  return {
    completed: completedSessions,
    total: totalSessions,
    percentage: Math.round((completedSessions / totalSessions) * 100)
  };
};

export const unlockNextSession = (currentSessionId) => {
  const currentSession = getBilingualTutorSessionById(currentSessionId);
  if (currentSession && currentSession.isCompleted) {
    const currentIndex = bilingualTutorSessions.findIndex(s => s.id === currentSessionId);
    const nextSession = bilingualTutorSessions[currentIndex + 1];
    if (nextSession) {
      nextSession.isUnlocked = true;
    }
  }
};
